import React from 'react';
import SAPB1ReportsCard from './SAPB1ReportsCard';
import img1 from '../../../public/images/SAP.png';
import img2 from '../../../public/images/Reportes-SAP-768x507.png';
import Button from '../Button';

const ReportsSection = () => { // Renombrado a un nombre más genérico
    return (
        <div className="min-h-screen container mx-auto flex flex-col items-center justify-center mt-16 mb-8 px-5 lg:px-0">
            <div className="w-full lg:w-3/4 space-y-8">
                <SAPB1ReportsCard
                    img={img1}
                    title="Reportes a la Medida para SAP Business One" // Nuevo título
                    description="En SICONS PERU, transformamos los datos de su empresa en información valiosa y fácil de entender. Nuestros reportes personalizados para SAP Business One le permiten obtener una visión clara y en tiempo real de su gestión, finanzas y operaciones." // Nueva descripción
                    items={[]}
                />
                <SAPB1ReportsCard
                    img={img2}
                    title="Nuestros Reportes en Excel Incluyen" // Título más descriptivo
                    description="Hemos diseñado una amplia gama de informes financieros y de gestión en formato Excel, creados para optimizar el análisis de la información registrada en cada área de su empresa, dándole el control total para tomar decisiones estratégicas con confianza." // Nueva descripción
                    items={[
                        "Estados financieros con sus anexos (Balance General, Estado de Resultados, etc.).", // Texto más amigable
                        "Cuentas por cobrar y saldos por documento.",
                        "Movimiento de kardex valorizado por almacén.",
                        "Reporte de activos fijos.",
                        "Pre-cálculo de impuestos mensuales (IGV - Renta).",
                        "Listado de documentos emitidos.",
                        "Ventas detalladas por ejecutivo de ventas.",
                        "Rentabilidad por producto.",
                        "Conciliación bancaria y operaciones pendientes.",
                        "Factor de importación.",
                        "Y otros reportes según sus necesidades específicas." // Texto más comercial
                    ]}
                    reverse
                />
            </div>
            {/* <Button title="Ver Todos los Servicios" /> */}
        </div>
    );
};

export default ReportsSection;